export default __webpack_public_path__ + "static/media/providence-homepage.57f6a104.PNG";